import { createTheme } from '@mui/material/styles';
import { components } from './components';
import { palette } from './palette';
import { typography } from './typography';

export const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 1024,
            md: 1366,
            lg: 1600,
            xl: 1920,
        },
    },
    components,
    typography,
    palette,
});
